<template>
    <b-container>
        <b-row>
            <b-col cols="12" class="webcam-lite-control">
                <b-btn @click="takePicture" block variant="primary"><i class="fa fa-camera"></i></b-btn>
                <b-form-file
                    :capture="true"
                    ref="wclc"
                    accept="image/*"
                    v-model="file"
                    plain
                    class="webcam-lite-file-control"
                    id="webcam-lite-file-control"
                ></b-form-file>
            </b-col>
        </b-row>
        <b-row v-if="showPreview" class="mt-3">
            <b-col cols="12">
                <b-row>
                    <b-col cols="12" md="6" offset-md="3" lg="4" offset-lg="4">
                        <b-img ref="preview" v-show="!!imageData" :src="imageData" fluid thumbnail></b-img>
                    </b-col>
                </b-row>
                <b-row v-if="!!imageData" align-h="center" class="mt-2">
                    <b-col cols="2" md="1">
                        <b-btn
                            size="sm"
                            variant="outline-danger"
                            align-self="center"
                            @click="reset"
                        ><i class="fa fa-trash"></i></b-btn>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
export default {
    props: {
        maxWidth: {
            type: Number,
            default: 0
        },
        maxHeight: {
            type: Number,
            default: 0
        },
        showPreview: {
            type: Boolean,
            default: true
        }
    },
    data: () => ({
        file: '',
        canvas: null,
        image: '',
        context: '',
        imageData: '',
        preview: null
    }),
    watch: {
        file(val) {
            if(!val) return;

            const fr = new FileReader();
            fr.addEventListener('load', e => {
                // this.photo = e.target.result;
                this.image.src = e.target.result;
            });
            fr.readAsDataURL(val);
        }
    },
    methods: {
        imageLoaded() {
            const w = this.image.width;
            const h = this.image.height;
            const ratio = w / h;

            let width;
            let height;
            if(!!this.maxWidth) {
                width = Math.min(this.maxWidth, w);
                height = Math.min(width / ratio, h);
            } else if(!!this.maxHeight) {
                height = Math.min(this.maxHeight, h);
                width = Math.min(height * ratio, w);
            }
            this.canvas.width = width;
            this.canvas.height = height;
            const context = this.canvas.getContext('2d');

            context.drawImage(this.image, 0, 0, width, height);


            this.imageData = this.canvas.toDataURL('image/png');
            this.$emit('input', this.imageData);
        },
        reset() {
            this.$refs.wclc.reset();
            this.$emit('input', null);
            this.imageData = '';
        },
        takePicture() {
            $('#webcam-lite-file-control').trigger('click');
        }
    },
    mounted() {
        // this.canvas = this.$refs.canvas;
        this.image = new Image();
        this.image.onload = this.imageLoaded;
        this.canvas = document.createElement('canvas');
        this.context = this.canvas.getContext('2d');
        !!this.showPreview && (this.preview = this.$refs.preview);
    },
    
}
</script>
<style scoped>
.webcam-lite-file-control {
    opacity: 0;
    width: 1px;
    height: 1px;
}
</style>
